import { render, staticRenderFns } from "./GlobalAudio.vue?vue&type=template&id=5716a4b0&scoped=true&"
import script from "./GlobalAudio.vue?vue&type=script&lang=js&"
export * from "./GlobalAudio.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAudio.vue?vue&type=style&index=0&id=5716a4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716a4b0",
  null
  
)

export default component.exports